window.ImageSkeleton = (function () {

  var SELECTOR = '.images-container';
  var MIN_SHOW_TIME = 450;

  function createSkeleton() {
    var el = document.createElement('div');
    el.className = 'product-image-skeleton is-hidden';
    return el;
  }

  function getTarget(container) {
    return container.querySelector('.rotate-image-container') || container;
  }

  function ensureSkeleton(container) {
    var target = getTarget(container);
    var sk = target.querySelector('.product-image-skeleton');
    if (!sk) {
      sk = createSkeleton();
      target.insertBefore(sk, target.firstChild);
    }
    return sk;
  }

  function showSkeleton(container, force) {
    container.classList.remove('is-loaded');

    var imgs = container.querySelectorAll('img:not(.oc-crossfade):not(.crossed-out)');
    imgs.forEach(function (img) {
      img.classList.remove('is-shown');
    });

    var sk = ensureSkeleton(container);
    sk.style.removeProperty('display');

    if (!force && sk.classList.contains('is-visible')) {
      return;
    }

    sk.classList.remove('is-visible');
    sk.classList.add('is-hidden');
    void sk.offsetWidth;
    sk.setAttribute('data-sk-start', String(Date.now()));

    requestAnimationFrame(function () {
      sk.classList.remove('is-hidden');
      sk.classList.add('is-visible');
    });
  }

  function hideSkeleton(container) {
    container._skBusy = false;
    container.classList.add('is-loaded');

    var sk = container.querySelector('.product-image-skeleton');
    if (sk && sk.classList.contains('is-visible')) {
      void sk.offsetWidth;
      sk.classList.remove('is-visible');
      sk.classList.add('is-hidden');
    } else if (sk) {
      sk.classList.remove('is-visible');
      sk.classList.add('is-hidden');
    }

    requestAnimationFrame(function () {
      container.querySelectorAll('img:not(.img-r):not(.oc-crossfade):not(.crossed-out)').forEach(function (img) {
        img.classList.add('is-shown');
      });
    });
  }

  function whenImageReady(img) {
    if (img.decode) {
      return img.decode().catch(function () {});
    }
    return Promise.resolve();
  }

  function imagesReady(container) {
    var images = Array.from(container.querySelectorAll('img:not(.img-r):not(.oc-crossfade):not(.crossed-out)'));
    if (!images.length) images = Array.from(container.querySelectorAll('img:not(.oc-crossfade):not(.crossed-out)'));
    return images.length > 0 && images.every(function (img) {
      return img.complete && img.naturalWidth > 0;
    });
  }

  function processContainer(container, force) {
    if (!container) return;
    if (!force && container.classList.contains('is-loaded')) return;
    if (!force && container._skBusy) {
      if (imagesReady(container)) hideSkeleton(container);
      return;
    }

    var token = (container._skGen || 0) + 1;
    container._skGen = token;
    container._skBusy = true;

    showSkeleton(container, force);

    var images = Array.from(container.querySelectorAll('img:not(.img-r):not(.oc-crossfade):not(.crossed-out)'));
    if (!images.length) {
      images = Array.from(container.querySelectorAll('img:not(.oc-crossfade):not(.crossed-out)'));
    }
    if (!images.length) {
      hideSkeleton(container);
      return;
    }

    var total = images.length;
    var loaded = 0;
    var finished = false;
    var startTime = Date.now();

    function tryHide() {
      if (container._skGen !== token) return;
      if (finished) return;
      loaded++;
      if (loaded < total) return;

      finished = true;

      var skEl = container.querySelector('.product-image-skeleton');
      var startedAttr = skEl && skEl.getAttribute('data-sk-start');
      var started = startedAttr ? parseInt(startedAttr, 10) : startTime;
      var minShow = (!startedAttr && skEl && skEl.classList.contains('is-visible'))
        ? 0
        : MIN_SHOW_TIME;
      var wait = Math.max(0, minShow - (Date.now() - started));

      Promise.all(images.map(whenImageReady)).then(function () {
        setTimeout(function () {
          if (container._skGen !== token) return;
          hideSkeleton(container);
        }, wait);
      });
    }

    requestAnimationFrame(function () {
      images.forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          tryHide();
          return;
        }

        img.addEventListener('load', tryHide, { once: true });
        img.addEventListener('error', tryHide, { once: true });

        if (img.dataset.src || img.classList.contains('lazy') || img.classList.contains('lazyload') || img.loading === 'lazy') {
          var check = setInterval(function () {
            if (img.complete && img.naturalWidth > 0) {
              clearInterval(check);
              tryHide();
            }
          }, 120);

          setTimeout(function () {
            clearInterval(check);
          }, 8000);
        }
      });
    });
  }

  function init(scope, force) {
    var root = document;
    var scoped = false;
    if (scope) {
      scoped = true;
      if (typeof scope === 'string') root = document.querySelector(scope) || document;
      else if (scope.jquery) root = scope[0] || document;
      else root = scope;
    }

    var containers = Array.prototype.slice.call(
      (root === document)
        ? document.querySelectorAll(SELECTOR)
        : root.querySelectorAll(SELECTOR)
    );
    if (root !== document && root.matches && root.matches(SELECTOR)) {
      containers.unshift(root);
    }

    containers.forEach(function (container) {
      if (!scoped && container.closest && container.closest('#productModal')) return;
      if (container.classList.contains('lightbox-slide-wrapper') || (container.closest && container.closest('.lightbox-overlay'))) return;
      processContainer(container, !!force);
    });
  }

  function reinit(scope) {
    init(scope, true);
  }

  function watch(target) {
    var root = target || document.querySelector('#content') || document.body;
    if (!root) return;

    var timer = null;
    var observer = new MutationObserver(function (mutations) {
      var found = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            (node.matches && node.matches(SELECTOR)) ||
            (node.querySelector && node.querySelector(SELECTOR))
          ) {
            found = true;
          }
        });
      });

      if (found) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          init(root);
        }, 50);
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function start() {
    init();
    watch();
    var cart = document.getElementById('cart');
    if (cart) watch(cart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  return {
    init: init,
    reinit: reinit,
    watch: watch
  };

})();